import { render } from "./ProfileEducation.vue?vue&type=template&id=67f24714"
import script from "./ProfileEducation.vue?vue&type=script&lang=js"
export * from "./ProfileEducation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__